import React from 'react'
import PropTypes from 'prop-types'

function Link({
  className,
  href,
  text,
  ...otherProps
}) {
  const isButtonType = className ? className.split(' ').includes('mz-btn') : false;

  return (
    <a
      className={`mz-link ${className}`}
      href={href}
      {...otherProps}
    >
      {
        isButtonType ? (
          <span>
            {text}
          </span>
        ) : (
          text
        )
      }
    </a>
  )
}

Link.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  text: PropTypes.string.isRequired,
}

Link.defaultProps = {
  className: ''
}

export default Link

